import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import RealisationsSection from '../components/sections/RealisationsSection';
import AboutSection from '../components/sections/AboutSection';
import ContactSection from '../components/sections/ContactSection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <RealisationsSection />
      <AboutSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
